export default {
    methods:{
        showAbnormalModal(){
            this.$error({
                title: '异常账户',
                content: '异常账户，请联系主管处理'
            })
        }
    }
}